import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./assets/scss/bundle.scss";
import App from "./App";
import { HashRouter } from "react-router-dom";
import { DataContainerProvider } from "./common/context/DataContainerProvider";

ReactDOM.render(
  <React.StrictMode>
    <HashRouter>
      <DataContainerProvider>
        <App />
      </DataContainerProvider>
    </HashRouter>
  </React.StrictMode>,
  document.getElementById("woodworksConfiguratorApp")
);
